module.exports = __webpack_public_path__ + "static/Onlay upper after-3f6dee0b2868662b4cb3daa658bbf6ed.jpg";